import { CSSProperties } from 'react';
import { ColumnsWitdhType, FilterItemType } from '../../../../types/types';
import { GridColumn } from '../types';
import { getDataType } from './getDataType';
import { getMatchModes } from './getMatchModes';
import { isMandatoryFilter } from '../../../../utils/isMandatoryFilter';

export const getColumns = (
  dataset: any,
  filter: any,
  lazyState: any,
  columnsWidth: ColumnsWitdhType,
  hasHorizontalOverflow: boolean,
  lockedFilterParams?: string[]
): GridColumn[] =>
  dataset.items
    .filter((column) => column.visible !== false)
    .map((column) => {
      const style: CSSProperties = {};
      if (column.minWidth) {
        style.minWidth = `${column.minWidth}em`;
      }
      if (column.maxWidth) {
        style.maxWidth = `${column.maxWidth}em`;
      }
      if (columnsWidth && columnsWidth[column.name]) {
        // Fixes bug with some columns with too long labels don't show correctly when the table does not horizontal scrolling
        style.width =
          hasHorizontalOverflow || column.label.length > 18
            ? `${columnsWidth[column.name]}px`
            : 'auto';
      }
      let bodyClassName = '';
      if (column.alignment && column.alignment !== 'left') {
        bodyClassName = `cell_${column.alignment}`;
      }
      let filterItem: FilterItemType | undefined;
      if (filter && filter.items && column.filterParam) {
        filterItem = filter.items.find(
          ({ name }) => name === column.filterParam
        );
      }
      const columnDataType = getDataType(column, filterItem?.control);
      const columnMatchModes = getMatchModes(column, filterItem);
      const hasFilter =
        columnDataType !== undefined &&
        column.filterParam &&
        !lockedFilterParams?.includes(column.filterParam);
      const filterActive =
        lazyState.filters &&
        lazyState.filters[column.name]?.constraints[0]?.value !== null;
      const mandatoryFilter = isMandatoryFilter(
        dataset,
        column.filterParam,
        dataset.datasetId
      );
      return {
        ...column,
        dataType: columnDataType,
        matchModes: columnMatchModes,
        hasFilter,
        filterActive,
        mandatoryFilter,
        bodyClassName,
        style,
        filterItem,
      };
    });
